import { TagsIndex } from '@/components/TagsIndex';
import { LabradorComponent } from '@/types/component';

export const LabradorTagsIndex: LabradorComponent = ({ type, data, meta, descendants, ...props }) => {
  return <TagsIndex tags={data.tags} headline="Alla ämnen" data-content-index={meta.contentIndex} {...props} />;
};
